import type { ButtonHTMLAttributes, ReactNode } from 'react'

import { Icon } from './Icon'
import styles from './PickButton.module.css'

export interface PickButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean
  icon?: ReactNode
}

export function PickButton({ selected = false, icon, children, className = '', ...props }: PickButtonProps) {
  return (
    <button type="button" className={`${styles.pick} ${selected ? styles.selected : ''} ${className}`} {...props}>
      <span className={styles.box}>{selected ? <Icon name="check" size={12} strokeWidth={3} /> : null}</span>
      {icon ? <span className={styles.icon}>{icon}</span> : null}
      {children}
    </button>
  )
}
